module.exports = __webpack_public_path__ + "static/media/data-management.7f0a9f71.mp4";